import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    itemheader: {
      display: 'flex',
      fontSize: 14,
      minHeight: 58,
      alignItems: 'center',
      padding: `${theme.spacing(1)}px 0`,
      borderBottom: '1px solid #e2e2e2',
      '& > div': {
        height: 'inherit',
      },
      '& .MuiGrid-container': {
        margin: 0,
        alignItems: 'center',
        height: 'inherit',
      },
      '& .MuiGrid-item': {
        padding: 0,
      },
    },
    titleheader: {
      fontSize: 14,
    },
    tablelegend: {
      textAlign: 'right',
      display: 'inline-flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: 'rgba(0, 0, 0, 0.45)',
      '& .MuiGrid-item': {
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
      },
    },
  }),
);
